











import { defineComponent } from '@nuxtjs/composition-api';
import useResponsive from '@shared/composables/useResponsive';
import useUiState from '@shared/composables/useUiState';

import AMXButton from '~/components/AMXButton.vue';

const { showLogoutModal } = useUiState();

const MEMBER_DROPDOWN_ITEMS = [
  {
    label: 'My Details',
    link: '/account#my-details',
  },
  {
    label: 'Order History',
    link: '/account#order-history',
  },
  {
    label: 'Sign Out',
    onClick: showLogoutModal,
  },
];

export default defineComponent({
  name: 'DropdownAccount',
  components: {
    AMXButton,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { isMobile } = useResponsive();

    const dropdownItems = MEMBER_DROPDOWN_ITEMS;

    return {
      isMobile,
      dropdownItems,
    };
  },
});
